import { faAlarmClock } from "@fortawesome/pro-regular-svg-icons";

import { useEffect, useRef, useState } from "react";

import { useTranslation } from "react-i18next";

import { Icon } from "@/components";
import { secondsToFormattedTime } from "@/utils/secondsToFormattedTime";

interface ICountdownTimer {
	currentStageEndTimestamp: number;
}

export default function CountdownTimer({ currentStageEndTimestamp }: ICountdownTimer) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`courses.progress.${key}`);
	const [timeLeft, setTimeLeft] = useState<number>(currentStageEndTimestamp);
	const timeRef = useRef<NodeJS.Timeout | undefined>(undefined);

	useEffect(() => {
		if (timeRef.current) {
			clearInterval(timeRef.current);
		}

		if (timeLeft <= 0) {
			return;
		}

		timeRef.current = setInterval(() => {
			setTimeLeft((prevTime: number) => {
				if (prevTime <= 1) {
					clearInterval(timeRef.current);

					return 0;
				}

				return prevTime - 1;
			});
		}, 1000);

		return () => clearInterval(timeRef.current);
	}, [currentStageEndTimestamp]);

	useEffect(() => {
		if (currentStageEndTimestamp) {
			const leftStageTimeInSeconds = Math.round((currentStageEndTimestamp - Date.now()) / 1000);

			if (leftStageTimeInSeconds > 0) {
				setTimeLeft(leftStageTimeInSeconds);
			} else {
				setTimeLeft(0);
			}
		} else {
			setTimeLeft(0);
		}
	}, [currentStageEndTimestamp]);

	return (
		<div
			className={`min-w-fit flex items-center justify-center gap-2 border-[1px] border-danger px-3 py-[10px] rounded-lg ${
				timeLeft <= 10 && timeLeft % 2 === 0 ? "bg-danger/20" : ""
			}`}
		>
			<Icon className="text-danger" icon={faAlarmClock} />
			<p className="text-danger text-[14px] font-semibold">
				{secondsToFormattedTime(timeLeft)} {ts("left")}
			</p>
		</div>
	);
}
